import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

export default function TopHeader() {
  const { state } = useContext(AuthContext);
  const [user, setUser] = useState(null);

  const userData = localStorage.getItem('userData');

  useEffect(() => {
    let mounted = true;
    if (mounted) setUser(JSON.parse(userData));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      {state ? (
        <div
          className={
            'flex flex-row justify-between px-4 py-2 fixed w-full lg:w-10/12 ml-0 lg:ml-64'
          }
        >
          <div></div>
          <div className={'flex flex-row items-center self-end'}>
            <h3
              className={'text-gray-600 font-medium text-base lg:text-lg mr-2'}
            >
              {user && user.name}
            </h3>
          </div>
        </div>
      ) : null}
    </>
  );
}
